import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import useLabels from 'infrastructure/js/hooks/useLabels';
import Validation from 'infrastructure/js/components/controls/controlsValidations.js';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
import InputSection from 'infrastructure/js/components/Dialog/InputSection/inputSection';
import TextField from 'infrastructure/js/components/controls/TextField/textField';

import './createQplTestFieldDialog.scss';

const maxLength30 = Validation.maxLength(30);

export function CreateQplTestFieldDialog({
                                           actions,
                                           sData,
                                           handleSubmit,
                                           pristine = false,
                                           reloadParentComponent = null

                                         }) {

  const dialogLabels = useLabels('mat.dialog.');
  const labels = useLabels('mat.administration.matsettings.dialog.createQplTestField.');

  const getDialogButtons = () => {
    return {
      left: [
        {
          id: 'cancel',
          text: dialogLabels.get('cancel'),
          action: actions.hide,
        },
      ],
      right: [
        {
          id: 'submit',
          text: dialogLabels.get('create'),
          bsStyle: 'primary',
          loading: sData.get('loading'),
          action: handleSubmit(onSubmit),
          disabled: pristine || sData.get('loading'),
        },
      ],
    };
  }

  const onSubmit = (data) => {
    let newData = {
      name: data.fieldName,
    };

    actions.submit(newData, null, reloadParentComponent);
  };

  const onHide = () => {
    actions.hide();
  };

  return (
    <Dialog
      id="create-qpl-test-field-dialog"
      className="create-qpl-test-field-dialog"
      titleText={labels.get('header.title')}
      show={true}
      onHide={onHide}
      sData={sData}
      footerButtons={getDialogButtons()}
      onEnterKeyPress={handleSubmit(onSubmit)}
    >
      <InputSection label={labels.get('name') + '*'} htmlFor="fieldName" className="no-margin">
        <TextField id="fieldName" name="fieldName" className="short-textfield" validate={[Validation.required, maxLength30]} />
      </InputSection>
    </Dialog>
  );
}

CreateQplTestFieldDialog.propTypes = {
  actions: PropTypes.object.isRequired,
  sData: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  reloadParentComponent: PropTypes.func,
};

export default reduxForm({
  form: 'createQplTestFieldDialog',
})(CreateQplTestFieldDialog);
